import React, { useContext, useEffect, useState } from 'react';
import { Button, Menu, Popover } from '@material-ui/core';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import classNames from 'classnames';
import { OrderReviewContext } from '../../OrderReviewContext';
import { ReportAttachmentsMenuItem } from './ReportAttachmentsMenuItem';
import QAPhotoUploadDialogMenuItem from './QAPhotoUploadDialogMenuItem/QAPhotoUploadDialogMenuItem';
import QAPhotoDownloadMenuItem from './QAPhotoDownloadMenuItem/QAPhotoDownloadMenuItem';
import { getOrderAttachments, getReportAttachments } from '../../../../services';

const AttachmentsMenuButton = ({ classes, order, setOrder }) => {
  // #region STATE
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [loadingAttachments, setLoadingAttachments] = useState(false);
  const [reportAttachments, setReportAttachments] = useState([]);
  const [adminAttachments, setAdminAttachments] = useState([]);
  // #endregion

  // #region HOOKS
  const { state, dispatch } = useContext(OrderReviewContext);
  // #endregion

  // #region COMPUTED
  const menuOpen = !!menuAnchorEl;
  const totalAttachments = reportAttachments.length + adminAttachments.length;
  // #endregion

  // #region FUNCTIONS
  const handleOpenMenu = evt => {
    setMenuAnchorEl(evt.currentTarget);
  };

  const handleCloseMenu = () => {
    setMenuAnchorEl(null);
  };

  const getExistingAdminAttachments = async () => {
    try {
      const existingAdminAttachments = await getOrderAttachments(state.orderLineId);
      setAdminAttachments(existingAdminAttachments);
      setLoadingAttachments(false);
    } catch (error) {
      setLoadingAttachments(false);
    }
  };

  const getExistingReportAttachments = async () => {
    try {
      const existingReportAttachments = await getReportAttachments(state.orderLineId);
      setReportAttachments(existingReportAttachments);
      setLoadingAttachments(false);
    } catch (error) {
      setLoadingAttachments(false);
    }
  };
  // #endregion

  // #region EFFECTS
  useEffect(() => {
    getExistingReportAttachments();
    getExistingAdminAttachments();
  }, []);
  // #endregion

  return (
    <>
      <Button
        onClick={handleOpenMenu}
        variant="contained"
        className={classNames(classes.buttonDropdownButton, classes.attachmentsButton)}
        endIcon={<KeyboardArrowUpIcon />}
      >
        Attachments
        {!!totalAttachments && (
          <span
            style={{
              position: 'absolute',
              top: -4,
              right: -4,
              width: 12,
              height: 12,
              borderRadius: '50%',
              background: 'red',
            }}
          />
        )}
      </Button>

      <Popover
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        anchorEl={menuAnchorEl}
        open={menuOpen}
        onClose={handleCloseMenu}
      >
        <>
          <ReportAttachmentsMenuItem
            orderLineId={state.orderLineId}
            onClose={handleCloseMenu}
            reportAttachments={reportAttachments}
            setReportAttachments={setReportAttachments}
            adminAttachments={adminAttachments}
            setAdminAttachments={setAdminAttachments}
            totalAttachments={totalAttachments}
            loadingAttachments={loadingAttachments}
          />

          {!state.isClient && !state.isUnderwriter && (
            <QAPhotoUploadDialogMenuItem
              orderLineId={state.orderLineId}
              order={order}
              setOrder={setOrder}
              onClose={handleCloseMenu}
            />
          )}

          {!state.isClient && !state.isUnderwriter && <QAPhotoDownloadMenuItem onClose={handleCloseMenu} />}
        </>
      </Popover>
    </>
  );
};

export default AttachmentsMenuButton;
